module.exports = __webpack_public_path__ + "static/media/pic6.ee849428.jpg";